var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._g({class:_vm.classes,attrs:{"role":"button"}},_vm.$listeners),[_c('FontAwesomeIcon',{attrs:{"icon":_vm.icon,"fixed-width":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }